function resolveChatRoute() {
    if (typeof window !== "undefined" && window.innerWidth > 1133) {
        return { name: "chatbox" };
    }

    return { name: "chat" };
}

const routes = [
    {
        path: "/chatbot",
        name: "chatbot",
        beforeEnter: () => resolveChatRoute(),
        component: () => import("@/views/chat/Index.vue"),
    },
    {
        path: "/chat/:id?",
        name: "chat",
        component: () => import("@/views/chat/Chat.vue"),
    },
    {
        path: "/chatbox/:id?",
        name: "chatbox",
        component: () => import("@/views/chat/ChatPc.vue"),
    },
];

export default routes;
